import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import { PlusCircle, List } from "react-feather";

const ProductsLanding = () => {
  const navigate = useNavigate();
  return (
    <Layout title="Products">
      <div className="max-w-3xl mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Add Product Card */}
          <Card className="flex flex-col items-center p-8 text-center hover:shadow-lg transition-shadow">
            <PlusCircle className="w-12 h-12 text-blue-600 mb-4" />
            <h2 className="text-xl font-bold mb-2">Add Product</h2>
            <p className="text-gray-600 mb-4">Create a new product and add it to your inventory.</p>
            <Button variant="primary" onClick={() => navigate("/products/add")}>Go to Add Product</Button>
          </Card>
          {/* Your Products Card */}
          <Card className="flex flex-col items-center p-8 text-center hover:shadow-lg transition-shadow">
            <List className="w-12 h-12 text-green-600 mb-4" />
            <h2 className="text-xl font-bold mb-2">Your Products</h2>
            <p className="text-gray-600 mb-4">View, search, and manage all your products in one place.</p>
            <Button variant="primary" onClick={() => navigate("/products/list")}>Go to Your Products</Button>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default ProductsLanding; 